//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const CcpDataFromTpeWhenBlank: FeatureFlag = {"Id":"CcpDataFromTpeWhenBlank","Label":"[10.16]CcpDataFromTpeWhenBlank","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Fetch data from TPE when CCP return null for payment data.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
